import Box from '@mui/material/Box';
import { Stream } from '@cloudflare/stream-react';
import { Container, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import GradientHeading from 'components/GradientHeading';

const HomeVideo = () => {
    const videoId = 'cfff3b3575543c1f36d0795b96ede107';
    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    return (
        <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
            <Box sx={{ textAlign: 'center', mb: 3 }}>
                <GradientHeading label="Event Highlight Video" />
                <Typography variant="h6" color="text.secondary">
                    Get a quick glimpse of INAACC Semarang 2026
                </Typography>
            </Box>

            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Box sx={{ width: isMd ? '80vw' : '90vw', maxWidth: 1200 }}>
                    <Box
                        sx={{
                            borderRadius: 3,
                            overflow: 'hidden',
                            boxShadow: (theme) => theme.shadows[6],
                            backgroundColor: 'background.paper',
                        }}
                    >
                        <Stream
                            controls
                            src={videoId}
                            autoplay={true}
                            muted={true}
                            loop={true}
                            style={{ display: 'block', width: '100%' }}
                        />
                    </Box>
                </Box>
            </Box>
        </Container>
    );
};

export default HomeVideo;
